RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const InsightsBarChartView = RivalIQ.apps.Dashboard.widgets.StackedBar.extend({

        loadData: function () {
            const me = this;

            const metric = new RivalIQ.models.MetricDefinition(me.dashboardModel.metric);

            return metric.fetch()
                .done(function (metric) {
                    me.collection = new RivalIQ.collections.MetricDefinitions([metric]);
                });
        },

        getTooltip: function () {
            const me = this;

            return {
                title: function (data) {
                    const idx = _.head(data).x;
                    const metric = me.collection.first();

                    const interval = (me.getProp('interval') || me.getProp('defaultInterval'));
                    if (interval === RivalIQ.utils.timePeriod.period.day) {
                        return RivalIQ.formatter.formats.date(metric.getDataDate(idx)[0]);
                    }

                    const bucketTimePeriod = metric.getBucketTimePeriod(idx);

                    return [
                        RivalIQ.formatter.formats.date(bucketTimePeriod.start),
                        RivalIQ.formatter.formats.date(bucketTimePeriod.end)
                    ].join(' - ');
                },
                content: function (data) {

                    const metric = me.collection.first();

                    const metricData = {
                        value: metric.format(data[0].value),
                        name: metric.getName()
                    };

                    return new App.views.ChartTooltip({
                        model: metricData
                    }).render().el.outerHTML;
                }
            };
        },

        getChartAttributes: function () {
            const me = this;

            const attrs = RivalIQ.apps.Dashboard.widgets.StackedBar.prototype.getChartAttributes.apply(me, arguments);

            const concept = me.collection.first();
            if (me.dashboardModel.metricDataType) {
                concept.description = _.defaults({
                    dataType: me.dashboardModel.metricDataType
                }, concept.description);
            }

            const overrides = _.pick(me.dashboardModel, [
                'height',
                'labels',
                'minLeftMargin'
            ]);

            const interval = (me.getProp('interval') || me.getProp('defaultInterval'));
            const period = _.get(RivalIQ.utils.timePeriod.interval, [interval], RivalIQ.utils.timePeriod.interval.daily);

            const annotationInformation = RivalIQ.str('incomplete_period', period);
            const annotations = _.map(concept.getIncompleteBuckets(), function (idx) {
                return {
                    x: idx,
                    icon: '\uf069',
                    information: annotationInformation
                };
            });

            if (interval) {
                _.extend(overrides, {
                    tickPosition: RivalIQ.enums.graph.position.MIDDLE
                });
            }

            return _.extend(attrs, {
                concept: concept,
                annotations: annotations
            }, overrides);
        },

        getMetricClassNames: function () {

            const me = this;
            return me.collection.invoke('getClassName');
        },

        getChartClassName: function () {
            const me = this;
            return me.getMetricClassNames();
        }
    });

    const InsightsBarChartWidget = RivalIQ.apps.Dashboard.models.Widget.extend({

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        view: InsightsBarChartView,

        processProps: function (props) {
            const me = this;

            props.interval ??= 'day';
            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric(props.objectType, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'storyDay'],
                    property: 'max_reach',
                    limit: -1,
                    useIntervalDomainFormatting: true
                }, props));
            }
            _.extend(me.metric, props);

            if (props.defaultInterval && !props.interval) {
                me.metric.interval = props.defaultInterval;
            }

            return props;
        },

        labels: {
            x: 'Date'
        },

        getMetricLabel: function () {
            const me = this;
            return me.metricLabel;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART, InsightsBarChartWidget);

});
